import React, { useState } from 'react';
import axios from 'axios';
import * as EmailValidator from 'email-validator';

const Signup = ({ listId }) => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(true);
  const [submitText, setSubmitText] = useState('sign up for news');
  const [submitPlaceholder, setSubmitPlaceholder] = useState(true);

  const apiUrl =
    'https://villagegreen-d82399.netlify.app/.netlify/functions/subscribe';

  //const apiUrl = 'http://localhost:8888/.netlify/functions/subscribe';

  const handleChange = (evt) => {
    const { value } = evt.target;
    if (value.length > 0) {
      setSubmitText('subscribe');
      // setSubmitDisabled(false);

      if (EmailValidator.validate(value)) {
        setSubmitDisabled(false);
      } else {
        setSubmitDisabled(true);
      }
    }
    setEmail(value);
  };

  const handleSubmit = async () => {
    const result = await axios.post(apiUrl, {
      e: email,
      listId: listId,
    });

    if (result.status === 200) {
      setSubscribed(true);
      // setSubmitPlaceholder('SIGN-UP RECEIVED');
      setSubmitText('THANK YOU');
      setSubmitDisabled(true);
      setEmail('');
    }
  };

  const handleFocus = () => {
    setSubmitPlaceholder(false);
  };
  const handleBlur = () => {
    setSubmitPlaceholder(true);
  };

  return (
    <div className="Signup">
      <p>
        <input
          type="text"
          placeholder={
            submitPlaceholder
              ? subscribed
                ? 'sign-up received'
                : 'your email'
              : null
          }
          value={email}
          onChange={(e) => handleChange(e)}
          onFocus={(e) => handleFocus(e)}
          onBlur={(e) => handleBlur(e)}
          disabled={subscribed}
        />
        <br />
        <button
          disabled={submitDisabled}
          class={submitPlaceholder && email.length === 0 ? 'active' : null}
          onClick={(evt) => handleSubmit(evt)}
        >
          {submitText}
        </button>
      </p>
    </div>
  );
};

export default Signup;



// WEBPACK FOOTER //
// ./src/js/components/Signup.jsx